import { txns } from './txnMiddleware'
import { combineReducers } from 'redux'
import signupCompCreate from "../modules/companyCreationLayout/data/reducer"

const rootReducer = (history) => combineReducers({
    signupCompCreate
})

export default rootReducer